import * as React from 'react';

import type { DegreesV1 } from 'bundles/degree-home/components/__generated__/DegreesV1';
import {
  CalendarCard as CalendarCardV2,
  MobileCalendarCard as MobileCalendarCardV2,
} from 'bundles/degree-home/components/v2/Calendar';
import { CurrentCoursesCard } from 'bundles/degree-home/components/v2/CurrentCourses/index';
import RecentGradesCard from 'bundles/degree-home/components/v2/RecentGrades/RecentGradesCard';
import SlackAccountInfoCard from 'bundles/degree-home/components/v2/SlackAccountInfoCard';
import SupportInfoCard from 'bundles/degree-home/components/v2/SupportInfoCard';
import { CalendarCard, MobileCalendarCard } from 'bundles/degree-home/components/v3-dpm/components/Calendar';
import { CalendarSyncCard } from 'bundles/degree-home/components/v3-dpm/components/Calendar/CalendarSyncCard';
import DegreeProgressCard from 'bundles/degree-home/components/v3-dpm/components/DegreeProgressCard';
import EstimatedGraduationCard from 'bundles/degree-home/components/v3-dpm/components/EstimatedGraduationDate/EstimatedGraduationCard';
import NudgeBannerRenderer from 'bundles/degree-home/components/v3-dpm/components/NudgeBannerRenderer';
import { PlanGraduationPrompt } from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/PlanGraduationPrompt';
import { PATHS } from 'bundles/degree-home/components/v3-dpm/constants/constants';
import DegreeMetadataContext from 'bundles/degree-home/components/v3-dpm/context/DegreeMetadataContext';
import { degreeV3EventShouldBeShown } from 'bundles/degree-home/components/v3-dpm/lib/experiments';
import PageContainer from 'bundles/degree-home/components/v3-dpm/pages/PageContainer';
import { MainContentHalfWidth, SidebarHalfWidth } from 'bundles/degree-home/components/v3-dpm/pages/pageStyles';

type Props = {
  degreeMetadata: DegreesV1;
};

const InProgress: React.VFC<Props> = ({ degreeMetadata }) => {
  const { id: degreeId, partnerIds, supportEmailAddress, supportLink } = degreeMetadata;
  const partnerId = partnerIds[0];

  return (
    <DegreeMetadataContext degreeMetadata={degreeMetadata}>
      {degreeV3EventShouldBeShown() && <NudgeBannerRenderer />}
      <PageContainer pathToRedirectToIfNotV3={PATHS.HOME} tabPanelValue={PATHS.IN_PROGRESS}>
        <MainContentHalfWidth>
          <DegreeProgressCard variant="summary" />
          <PlanGraduationPrompt variant="in-progress" />
          <EstimatedGraduationCard variant="detail" />
          <CurrentCoursesCard degreeId={degreeId} />
          {degreeV3EventShouldBeShown() ? (
            <MobileCalendarCard degreeId={degreeId} />
          ) : (
            <MobileCalendarCardV2 degreeId={degreeId} />
          )}
          <RecentGradesCard degreeId={degreeId} />
          <SlackAccountInfoCard degreeId={degreeId} />
          <CalendarSyncCard />
          <SupportInfoCard
            degreeId={degreeId}
            supportEmailAddress={supportEmailAddress}
            partnerId={partnerId}
            supportLink={supportLink}
          />
        </MainContentHalfWidth>
        <SidebarHalfWidth>
          {degreeV3EventShouldBeShown() ? <CalendarCard degreeId={degreeId} /> : <CalendarCardV2 degreeId={degreeId} />}
        </SidebarHalfWidth>
      </PageContainer>
    </DegreeMetadataContext>
  );
};

export default InProgress;
